import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  const addItem = (product) => {
    setItems(current => {
      const existing = current.find(x => x.id === product.id);
      if (existing) {
        return current.map(x =>
          x.id === product.id ? { ...x, q: x.q + 1 } : x
        );
      }
      return [...current, { ...product, q: 1 }];
    });
  };

  const removeItem = (productId) => {
    setItems(current => current.filter(x => x.id !== productId));
  };

  const updateQuantity = (productId, q) => {
    if (q <= 0) {
      removeItem(productId);
      return;
    }
    setItems(current =>
      current.map(x => x.id === productId ? { ...x, q } : x)
    );
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((s, x) => s + x.price * x.q, 0);
  const count = items.reduce((s, x) => s + x.q, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQuantity, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}
